import { useEffect, useState } from "react";
import { getPrizeStats } from "@/app/common-service";

const PrizeStatsBanner = () => {
  const [totalPrizeWon, setTotalPrizeWon] = useState<string | null>(null);

  useEffect(() => {
    const loadPrizeStats = async () => {
      try {
        const response = await getPrizeStats();
        const totalPrizeWon = await response.json();

        setTotalPrizeWon(totalPrizeWon);
      } catch (error) {
        console.error("Failed to load prize stats:", error);
      }
    };

    loadPrizeStats();
  }, []);

  return (
    <div className="competition-info">
      <h2 className="animate">EST. 1999 – {totalPrizeWon} IN PRIZES</h2>
      <p className="animate">Guaranteed winners every week</p>
      <div className="animate buttons-container">
        <a className="btn orange" href="/prizes/cars">
          DREAM CAR<span className="button-arrow arrow-effect"></span>
        </a>
        <a className="btn white" href="/how-to-play">
          FIRST VISIT?<span className="button-arrow arrow-effect"></span>
        </a>
      </div>
    </div>
  );
};

export default PrizeStatsBanner;